import TopBarControl from '@/classes/TopBarControls/TopBarControl'
import sizes from '@/constants/ui-kit/standard/sizes'
import styles from '@/constants/ui-kit/standard/styles'
import TopBarButtonIcon from '@/components/Gadgets/TheTopBar/controls/TopBarButtonIcon'

export default class TopBarButtonIconGenerator {
  static create({
    buttonIcon,
    show,
    buttonStyle,
    projectTypesSupported,
    eventHandler,
  }) {
    return new TopBarControl({
      component: TopBarButtonIcon,
      show,
      projectTypesSupported,
      eventName: 'button-click',
      eventHandler,
      props: {
        buttonIcon,
        size: sizes.SM,
        buttonStyle: buttonStyle || styles.LIGHT,
      },
    })
  }
}
